export default class Csr {
  constructor (
    commonName, organization, organizationalUnit, localityName,
    stateOrProvinceName, countryName) {

    this.commonName = commonName;
    this.organization = organization;
    this.organizationalUnit = organizationalUnit;
    this.localityName = localityName;
    this.stateOrProvinceName = stateOrProvinceName;
    this.countryName = countryName;

    this.csrData = {};

    this.generate()
  }

  generate() {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: ATLEX_OBJ.ajax_url,
        type: 'POST',
        data: {
          action: 'generate_csr',
          data: {
            commonName: this.commonName,
            organization: this.organization,
            organizationalUnit: this.organizationalUnit,
            localityName: this.localityName,
            stateOrProvinceName: this.stateOrProvinceName,
            countryName: this.countryName,
          },
        },
        success: (data) => {
          resolve(JSON.parse(data));
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }
}